import { memo, useCallback } from 'react'
import { Fade, IconButton, styled } from '@mui/material'
import Badge, { BadgeProps } from '@mui/material/Badge'
import { ArrowDropDownIcon } from '$common/icons/arrow-drop-down'
import { useRoomUnseenCountSync } from '$logic/room-seen/react-hook'
import { goToLastMessage, useOpenedRoomId } from '$logic/opened-room'
import { toLocale } from '$func/text'

const StyledIconButton = styled(IconButton)`
  width: 44px;
  height: 44px;
  padding: 10px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  &:hover {
    background-color: #f6f6f6;
  }
`

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '50%',
    padding: '5px 8px',
    lineHeight: '8px',
    color: theme.palette.white,
    ...theme.typography.caption1,
  },
}))

export const ScrollToBottom = memo(
  ({ shouldHide }: { shouldHide: boolean }) => {
    const roomId = useOpenedRoomId()
    const unseenCount = useRoomUnseenCountSync(roomId)

    const handleScrollToBottom = useCallback(() => {
      goToLastMessage({ block: 'start' })
    }, [])

    if (shouldHide && !unseenCount) return null

    return (
      <Fade in>
        <div>
          <StyledBadge
            badgeContent={toLocale(unseenCount)}
            invisible={!unseenCount}
            color="success"
          >
            <StyledIconButton onClick={handleScrollToBottom}>
              <ArrowDropDownIcon sx={{ width: '24px', height: '24px' }} />
            </StyledIconButton>
          </StyledBadge>
        </div>
      </Fade>
    )
  },
  (prev, next) => prev.shouldHide === next.shouldHide,
)
